// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__o1JOT","inner":"Form_inner__1mF04","range":"Form_range__31iGV","name":"Form_name__1Z_jO","actions":"Form_actions__3h08E"};